(() => {
  const addBusinessDays = (startDate, businessDays) => {
    const date = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      12
    );
    let added = 0;

    while (added < businessDays) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }

    return date;
  };

  if (customElements.get('delivery-estimate')) return;

  customElements.define(
    'delivery-estimate',
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const configuredMin = Number.parseInt(this.dataset.minBusinessDays, 10);
        const configuredMax = Number.parseInt(this.dataset.maxBusinessDays, 10);

        if (!Number.isFinite(configuredMin) || !Number.isFinite(configuredMax)) return;

        const minDays = Math.max(1, Math.min(configuredMin, configuredMax));
        const maxDays = Math.max(minDays, Math.max(configuredMin, configuredMax));
        const now = new Date();
        const minDate = addBusinessDays(now, minDays);
        const maxDate = addBusinessDays(now, maxDays);
        const locale = document.documentElement.lang || navigator.language || 'en';
        const format = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });

        const bold = (date) => {
          const strong = document.createElement('strong');
          strong.textContent = format.format(date);
          return strong;
        };

        this.replaceChildren(
          document.createTextNode('Order now to receive between '),
          bold(minDate),
          document.createTextNode(' and '),
          bold(maxDate)
        );
      }
    }
  );
})();
